import { render, staticRenderFns } from "./AppPageTitle.vue?vue&type=template&id=59b08b3a&"
import script from "./AppPageTitle.vue?vue&type=script&lang=js&"
export * from "./AppPageTitle.vue?vue&type=script&lang=js&"
import style0 from "./AppPageTitle.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports